import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HomeService } from '../../../pages/home/services/home.service';

@Component({
  selector: 'app-clockin-job-modal',
  templateUrl: './clockin-job-modal.component.html',
  styleUrls: ['./clockin-job-modal.component.css']
})
export class ClockinJobModalComponent implements OnInit {
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  tcClockIOIgnoreJobPhase: boolean;
  jobs: any[] = [];
  phases: any[] = [];
  prefillJP: boolean;
  userAction: string;

  constructor(private homeService: HomeService, private bsModalRef: BsModalRef) {  }

  ngOnInit(): void {
    this.prefillJP = this.portalSettings.PrefillPerviousJobPhase.ConfigValue == "1";
    this.tcClockIOIgnoreJobPhase = this.portalSettings.TCClockIOIgnoreJobPhase.ConfigValue == "1";
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    this.getJobs();
  }

  getJobs() {
    this.homeService.getJobs("TC").then((response: any) => {
      var jobs = response;
      for (var i = 0; i < jobs.length; i++) {
        jobs[i].DisplayValue = "JCCo " + jobs[i].JCCo + " - " + jobs[i].JobDisplayName;
        if (this.employeeInfo.LastUsedJCJMKeyID != null && jobs[i].JCJMKeyID == this.employeeInfo.LastUsedJCJMKeyID && this.prefillJP) {
          this.formData.selectedJob = jobs[i];
        }
      }
      if (this.formData.selectedJob != null) {
        this.getPhases();
      }
      this.jobs = jobs;
      if (this.tcClockIOIgnoreJobPhase) {
        this.jobs.unshift({ JCJMKeyID: null, DisplayValue: "No Job", JCCo: null, Job: "", JobDescription: "", JobDisplayName: "" });
      }
    });
  }

  jobChanged() {
    this.formData.selectedPhase = null;
    this.homeService.setJob(this.formData.selectedJob.JCJMKeyID, this.employeeInfo.UserKeyID);
    this.getPhases();
  }

  getPhases() {
    this.phases = [];
    if (this.formData.selectedJob?.JCJMKeyID != null) {
      this.homeService.getPhasesByJCJMKeyID(this.formData.selectedJob.JCJMKeyID).then((response: any) => {
        var phases = response;
        this.phases = phases;
        if (this.prefillJP) {
          for (var i = 0; i < phases.length; i++) {
            if (this.employeeInfo.LastUsedJCJPKeyID != null && this.employeeInfo.LastUsedJCJPKeyID == phases[i].JCJPKeyID) {
              this.formData.selectedPhase = phases[i];
            }
          }
        }
        if (this.tcClockIOIgnoreJobPhase) {
          this.phases.unshift({ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null });
        }
      });
    } else {
      if (this.tcClockIOIgnoreJobPhase) {
        this.phases.unshift({ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null });
      }
    }
  }

  clockInClicked() {
    this.userAction = "Clock In";
    this.bsModalRef.hide();
  }

  cancelClicked() {
    this.userAction = "cancel";
    this.bsModalRef.hide();
  }
}
